import React, { useCallback, useMemo, useState } from "react";
import { withRouter } from "react-router-dom";
import {useUserSettings} from "../../context/CurrentUserContext";
import * as AuthenticationProvider from "../../modules/AuthenticationProvider";
import {
    EuiHeader,
    EuiHeaderLinks,
    EuiHeaderLink,
    EuiIcon,
    EuiHeaderSectionItem,
    EuiHeaderSectionItemButton,
    htmlIdGenerator,
    EuiPopover,
    EuiContextMenu,
    EuiFlexGroup,
    EuiFlexItem,
  } from '@elastic/eui';
import { LinkUser } from "./LinkUser";
import { EmailSendButton } from "./EmailSend";
import { StateApp } from "./EstadoApp/container";
import { SelectorIdioma } from "../ConfiguracionIdioma";
import reactSvg from "./logo.svg";
import { useLanguage } from "../../../../shared/hooks/Language";
import { SelectorPerfil } from "../ConfiguracionPerfil";
import "./style.css";


export interface navigationType {
    id?: number;
    key?: string;
    name?: string;
    title?: string;
    to?: string;
    items?: any;
    panel?:number;
    disabled?: boolean;
    perfil?: Array<string>;
    excludeperfil?: Array<string>;
    permisos?: Array<string>;
    menuAdministracion?: boolean;
    show?: boolean;
    className?:string;
  }

  const _Perfiles  = {RECURSOS_HUMANOS:'RRH',USUARIO:'USR',RESPONSABLE_AREA:'RAR',FISCAL:'FIS',FACTURACION:'FAC',ADMINISTRADOR:'ADM'}
  interface PermisosMenuUser{
    Perfil: 'RRH' | 'USR' | 'RAR' | 'FIS' | 'FAC' | 'ADM'
    Partes:{show:boolean}
    ValidacionPartes:{show:boolean, subMenu:{validaciones:boolean,detalle:boolean,control:boolean}}
    Informes:{show:boolean}
    Maestros:{show:boolean, subMenu:{proyectos:boolean, areas:boolean, sociedades:boolean, funciones:boolean, subFunciones:boolean, conceptosFacturacion:boolean}}
    Usuarios:{show:boolean, subMenu:{administracion:boolean,historicoAdjuntosExpatriados:boolean,permisos:boolean,administracionExpatriados:boolean,informacionRolesExpatriados:boolean}}
    RecursosHumanos:{show:boolean}
    MiConfiguracion:{show:boolean}
    ConfiguracionApp:{show:boolean}
    Facturacion:{show:boolean, subMenu:{facturacion:boolean,validaciones:boolean,ajustes:boolean,informes:boolean}}
  }

  const PermisosMenuDefault = (perfil:string):PermisosMenuUser=>{

    const _permisos:PermisosMenuUser[] = [
    {
      Perfil:'RRH',
      Partes:{show:true},
      ValidacionPartes:{show:false,subMenu:{validaciones:false,detalle:false,control:false}},
      Informes:{show:false},
      Maestros:{show:false,subMenu:{proyectos:false, areas:false, sociedades:false, funciones:false, subFunciones:false, conceptosFacturacion:false}},
      Usuarios:{show:false, subMenu:{administracion:false,historicoAdjuntosExpatriados:false,permisos:false,administracionExpatriados:false,informacionRolesExpatriados:false}},
      RecursosHumanos:{show:true},
      MiConfiguracion:{show:true},
      ConfiguracionApp:{show:false},
      Facturacion:{show:false, subMenu:{facturacion:false,validaciones:false,ajustes:false,informes:false}}
    },
    {
      Perfil:'USR',
      Partes:{show:true},
      ValidacionPartes:{show:false,subMenu:{validaciones:false,detalle:false,control:false}},
      Informes:{show:false},
      Maestros:{show:false, subMenu:{proyectos:false, areas:false, sociedades:false, funciones:false, subFunciones:false, conceptosFacturacion:false}},
      Usuarios:{show:false, subMenu:{administracion:false,historicoAdjuntosExpatriados:false,permisos:false, administracionExpatriados:false,informacionRolesExpatriados:false}},
      RecursosHumanos:{show:false},
      MiConfiguracion:{show:true},
      ConfiguracionApp:{show:false},
      Facturacion:{show:false, subMenu:{facturacion:false,validaciones:false,ajustes:false,informes:false}}
    },
    {
      Perfil:'RAR',
      Partes:{show:true},
      ValidacionPartes:{show:true,subMenu:{validaciones:true,detalle:true,control:false}},
      Informes:{show:false},
      Maestros:{show:false,subMenu:{proyectos:false, areas:false, sociedades:false, funciones:false, subFunciones:false, conceptosFacturacion:false}},
      Usuarios:{show:false, subMenu:{administracion:false,historicoAdjuntosExpatriados:false,permisos:false, administracionExpatriados:false,informacionRolesExpatriados:false}},
      RecursosHumanos:{show:false},
      MiConfiguracion:{show:true},
      ConfiguracionApp:{show:false},
      Facturacion:{show:false, subMenu:{facturacion:false,validaciones:false,ajustes:false,informes:false}}
    },
    {
      Perfil:'FIS',
      Partes:{show:true},
      ValidacionPartes:{show:true,subMenu:{validaciones:true,detalle:true,control:true}},
      Informes:{show:true},
      Maestros:{show:true,subMenu:{proyectos:true, areas:true, sociedades:true, funciones:true, subFunciones:true, conceptosFacturacion:true}},
      Usuarios:{show:false, subMenu:{administracion:false,historicoAdjuntosExpatriados:false,permisos:false, administracionExpatriados:false,informacionRolesExpatriados:false}},
      RecursosHumanos:{show:false},
      MiConfiguracion:{show:true},
      ConfiguracionApp:{show:false},
      Facturacion:{show:false, subMenu:{facturacion:false,validaciones:false,ajustes:false,informes:false}}
    },
    {
      Perfil:'FAC',
      Partes:{show:true},
      ValidacionPartes:{show:true,subMenu:{validaciones:true,detalle:true,control:true}},
      Informes:{show:false},
      Maestros:{show:false,subMenu:{proyectos:false, areas:false, sociedades:false, funciones:false, subFunciones:false, conceptosFacturacion:false}},
      Usuarios:{show:false, subMenu:{administracion:false,historicoAdjuntosExpatriados:false,permisos:false, administracionExpatriados:false,informacionRolesExpatriados:false}},
      RecursosHumanos:{show:false},
      MiConfiguracion:{show:true},
      ConfiguracionApp:{show:false},
      Facturacion:{show:false, subMenu:{facturacion:false,validaciones:false,ajustes:false,informes:false}}
    },
    {
      Perfil:'ADM',
      Partes:{show:true},
      ValidacionPartes:{show:true,subMenu:{validaciones:true,detalle:true,control:true}},
      Informes:{show:true},
      Maestros:{show:true, subMenu:{proyectos:true, areas:true, sociedades:true, funciones:true, subFunciones:true, conceptosFacturacion:true}},
      Usuarios:{show:true, subMenu:{administracion:true,historicoAdjuntosExpatriados:true,permisos:true, administracionExpatriados:true,informacionRolesExpatriados:true}},
      RecursosHumanos:{show:true},
      MiConfiguracion:{show:true},
      ConfiguracionApp:{show:true},
      Facturacion:{show:true, subMenu:{facturacion:true,validaciones:true,ajustes:true,informes:true}}
    }
    ]

    return _permisos.filter((f:PermisosMenuUser)=> f.Perfil === perfil)[0]
  }

  const RolesExpatriadosPermisos:any[] = [
    {
      AdministraExpatriados:true,
      Rol:'Administrador de expatriados',
      RolKey:'administra-expatriados',
      Facturacion:{
        facturacion:true, validacion:true, ajustes:true, informes:true
      }
    },
    {
      AdministraExpatriadosLocal:true,
      Rol:'Administrador de expatriados local',
      RolKey:'administra-expatriados-local',
      Facturacion:{
        facturacion:true, validacion:true, ajustes:false, informes:false
      }
    },
    {
      ConsultaExpatriados:true,
      Rol:'Consulta de expatriados',
      RolKey:'consulta-expatriados',
      Facturacion:{
        facturacion:true, validacion:false, ajustes:false, informes:false
      }
    }
  ]

  const PermisosRolExpatriados = (user:any) => {
    let _permisos:any = undefined;

    if(user.administraExpatriados){
      _permisos = RolesExpatriadosPermisos.filter((f:any)=> f.AdministraExpatriados===true)[0];
    }else{
      if(user.administraExpatriadosLocal){
        _permisos = RolesExpatriadosPermisos.filter((f:any)=> f.AdministraExpatriadosLocal===true)[0];

        // if(user.consultaExpatriados){
        //   const _permisosConsulta =  RolesExpatriadosPermisos.filter((f:any)=> f.ConsultaExpatriados===true)[0];

        //   //_permisos.validacion = 
        // }

      }else{
        if(user.consultaExpatriados){
          _permisos=RolesExpatriadosPermisos.filter((f:any)=> f.ConsultaExpatriados===true)[0]
        }
      }
    }
    
    return _permisos;
    
    // return (
    //     user.administraExpatriados === true ? RolesExpatriadosPermisos.filter((f:any)=> f.AdministraExpatriados===true)[0]
    //     :
    //     user.administraExpatriadosLocal === true ? RolesExpatriadosPermisos.filter((f:any)=> f.AdministraExpatriadosLocal===true)[0]
    //     :
    //     user.consultaExpatriados === true ? RolesExpatriadosPermisos.filter((f:any)=> f.ConsultaExpatriados===true)[0]
    //     : undefined
    //   )

 }


  const PermisosMenu = (user:any):PermisosMenuUser=>{
    let _permisosPorPerfil:PermisosMenuUser = PermisosMenuDefault(user.perfil);
    
    const _permisosDinamicosPerfil:string[] = [_Perfiles.RECURSOS_HUMANOS,_Perfiles.USUARIO,_Perfiles.RESPONSABLE_AREA,_Perfiles.FACTURACION,_Perfiles.FISCAL];

    if(_permisosDinamicosPerfil.includes(user.perfil))
    {
      const _permisosRolExpatriado:any = PermisosRolExpatriados(user);
      const _isRoleExpatriados: boolean = _permisosRolExpatriado!==undefined;
      const _isAdministradorUsuarios:boolean = (user.administraUsuarios);
      const _showUsersEpatriadosPanel:boolean = (_isRoleExpatriados);
      const _isCTU:boolean = user.controlUsuarios;

      switch (user.perfil) {
        case _Perfiles.RECURSOS_HUMANOS:
        case _Perfiles.USUARIO:{
          _permisosPorPerfil.ValidacionPartes.show = _isCTU;
          _permisosPorPerfil.ValidacionPartes.subMenu.control = _isCTU;
          _permisosPorPerfil.Maestros.show = _isAdministradorUsuarios;
          _permisosPorPerfil.Maestros.subMenu.proyectos = _isAdministradorUsuarios;
        }break;
        case _Perfiles.RESPONSABLE_AREA:{
          _permisosPorPerfil.ValidacionPartes.subMenu.control = _isCTU;
          _permisosPorPerfil.Maestros.show = _isAdministradorUsuarios;
          _permisosPorPerfil.Maestros.subMenu.proyectos = _isAdministradorUsuarios;
          break;
        }
      }

      _permisosPorPerfil = {
        ..._permisosPorPerfil,
        ...{Usuarios:{show:(_isAdministradorUsuarios || _showUsersEpatriadosPanel), subMenu:{administracion:_isAdministradorUsuarios,historicoAdjuntosExpatriados:_isRoleExpatriados,
          permisos:_isAdministradorUsuarios, administracionExpatriados:_showUsersEpatriadosPanel, informacionRolesExpatriados:_isRoleExpatriados}}},
        ...{Facturacion:{show:_isRoleExpatriados, 
              subMenu:{facturacion:(_isRoleExpatriados&&_permisosRolExpatriado.Facturacion.facturacion),
              validaciones:(_isRoleExpatriados&&_permisosRolExpatriado.Facturacion.validacion),
              ajustes:(_isRoleExpatriados&&_permisosRolExpatriado.Facturacion.ajustes),
              informes: (_isRoleExpatriados&&_permisosRolExpatriado.Facturacion.informes)}}}
      }

    }
    
    return _permisosPorPerfil;
  }

  const Navigation = (props: any) => {
    const {currentUser,setCurrentUser}:any = useUserSettings();
    
    const haveDatacurrentUser = useMemo(()=> currentUser!==undefined && currentUser!==null && Object.keys(currentUser).length>0 ,[currentUser])

    return haveDatacurrentUser ? (<ViewNavigation currentUser={currentUser} {...props} setUser={setCurrentUser}/>) : null
  }


  const ViewNavigation = (props:any)=>{
    const {currentUser,setUser}=props;
    const {translate} = useLanguage();

    const _permisosRolExpatriado = useMemo(()=> currentUser && PermisosRolExpatriados(currentUser) ,[currentUser])

    const menuItems: Array<navigationType> = useMemo(()=>{ 
      const _permisos:PermisosMenuUser = PermisosMenu(currentUser); 

      return [
          {
              key: "partes",
              name: "Partes",
              title: "Partes",
              to: "/Partes",
              items: [],
              show:(_permisos.Partes.show)
          },
          {
            id: 0,
            key: "validaciones",
            name: "Validaciones",
            title: "Validaciones",
            to: "/Validaciones",
            items: [ 
              {
                key: "validacionpartes",
                name: "Validación de partes",
                title: "ValidacionPartes",
                to: "/Validaciones",
                items: [],
                show:(_permisos.ValidacionPartes.subMenu.validaciones)
              },
              {
                key: "detallepartes",
                name: "Detalle de partes",
                title: "DetallePartes",
                to: "/Validaciones/DetallePartes",
                items: [],
                show:(_permisos.ValidacionPartes.subMenu.detalle)
              },
              {
              key: "controlusuarios",
              name: "Control Usuarios",
              title: "ControlUsuarios",
              to: "/Validaciones/ControlUsuarios",
              items: [],
              show:(_permisos.ValidacionPartes.subMenu.control)
              }
            ],
            show:(_permisos.ValidacionPartes.show)
          },
          {
            id: 0,
            key: "informes",
            name: "Informes",
            title: "Informes",
            to: "/Informes",
            items: [
              {
                key: "partessinadjuntos",
                name: "Partes Sin Adjuntos",
                title: "Partes Sin Adjuntos",
                to: "/Informes/PartesSinAdjuntos",
                items: []
              },
              {
                key: "personasmascincuentaporc",
                name: "Personas >50%",
                title: "Personas >50%",
                to: "/Informes/PersonasMasCincuentaPorc",
                items: []
              },
              {
                key: "personasmenoscincuentaporc",
                name: "Personas <50%",
                title: "Personas <50%",
                to: "/Informes/PersonasMenosCincuentaPorc",
                items: []
              },
              {
                key: "horaspordnsg",
                name: "Horas Por DN/SG",
                title: "HorasPorDNSG",
                to: "/Informes/HorasPorDNSG",
                items: []
              },
              {
                key: "horasporsociedad",
                name: "Horas Por Sociedad",
                title: "Sociedades Horas",
                to: "/Informes/HorasPorSociedad",
                items: []
              },
              {
                key: "horasporproyecto",
                name: "Horas Por Proyecto",
                title: "HorasPorProyecto",
                to: "/Informes/HorasPorProyecto",
                items: []
              },
              {
                key: "horasporfuncion",
                name: "Horas Por Función",
                title: "HorasPorFuncion",
                to: "/Informes/HorasPorFuncion",
                items: []
              },
              {
                key: "horasporsubfuncion",
                name: "Horas Por SubFunción",
                title: "HorasPorSubFuncion",
                to: "/Informes/HorasPorSubFuncion",
                items: []
              },
              {
                key: "horasporconcepto",
                name: "Horas Por Concepto",
                title: "Conceptos Horas",
                to: "/Informes/HorasPorConcepto",
                items: []
              },
              {
                key: "conceptosporpais",
                name: "Horas Por Pais",
                title: "HorasPorPais",
                to: "/Informes/HorasPorPais",
                items: []
              },
              {
                key: "horascontrolutilidad",
                name: "Horas Control/Utilidad",
                title: "HorasControlUtilidad",
                to: "/Informes/HorasControlUtilidad",
                items: []
              }
            ],
            show:(_permisos.Informes.show)
          },
          {
              id: 0,
              key: "maestros",
              name: "Maestros",
              title: "Maestros",
              to: "/Maestros",
              items: [
                  {
                      key: "proyectos",
                      name: "Proyectos",
                      title: "Proyectos",
                      to: "/Maestros/Proyectos",
                      items: [],
                      show:(_permisos.Maestros.subMenu.proyectos)
                  },
                  {
                    key: "areas",
                    name: "Areas",
                    title: "Areas",
                    to: "/Maestros/Areas",
                    items: [],
                    show:(_permisos.Maestros.subMenu.areas)
                  },
                  {
                    key: "sociedades",
                    name: "Sociedades",
                    title: "Sociedades",
                    to: "/Maestros/Sociedades",
                    items: [],
                    show:(_permisos.Maestros.subMenu.sociedades)
                  },
                  {
                    key: "funciones",
                    name: "Funciones",
                    title: "Funciones",
                    to: "/Maestros/Funciones",
                    items: [],
                    show:(_permisos.Maestros.subMenu.funciones)
                  },
                  {
                    key: "subfunciones",
                    name: "SubFunciones",
                    title: "SubFunciones",
                    to: "/Maestros/SubFunciones",
                    items: [],
                    show:(_permisos.Maestros.subMenu.subFunciones)
                },
                {
                  key: "conceptosfacturacion",
                  name: "Conceptos Facturación",
                  title: "Conceptos Facturación",
                  to: "/Maestros/ConceptosFacturacion",
                  items: [],
                  show:(_permisos.Maestros.subMenu.conceptosFacturacion)
                }
              ],
              show:(_permisos.Maestros.show)
          },
          {
            id: 0,
            key: "usuarios",
            name: "Usuarios",
            title: translate('usuarios'),
            to: "/Usuarios",
            items: [
              {
                key: "administracionusuarios",
                name: translate("administracion"),
                title: translate("administracion"),
                to: "/Usuarios/Administracion",
                items: [],
                show:(_permisos.Usuarios.subMenu.administracion)
              },
              {
                key: "permisosusuarios",
                name: "Permisos",
                title: "Permisos",
                to: "/Usuarios/Permisos",
                items: [],
                show:(_permisos.Usuarios.subMenu.permisos)
              },
              {
                key: "administracionusuariosexpatriados",
                name: translate("administracion-expatriados"),
                title: translate("administracion-expatriados"),
                to: "/Usuarios/AdministracionExpatriados",
                items: [],
                show:(_permisos.Usuarios.subMenu.administracionExpatriados)
              },
              {
                key: "informacionrolesexpatriados",
                name: translate("informacion-roles-expatriados"),
                title: translate("informacion-roles-expatriados"),
                to: "/Usuarios/InformacionRolesExpatriados",
                items: [],
                show:(_permisos.Usuarios.subMenu.informacionRolesExpatriados)
              },
              {
                key: "historicoadjuntosexpatriados",
                name: translate("historico-adjuntos-expatriados"),
                title: translate("historico-adjuntos-expatriados"),
                to: "/Usuarios/HistoricoAdjuntosExpatriados",
                items: [],
                show:(_permisos.Usuarios.subMenu.historicoAdjuntosExpatriados)
              }
            ],
            show:(_permisos.Usuarios.show)
          },
          {
            key: "costos",
            name: "Costos",
            title: "RRHH",
            to: "/Costos",
            items: [],
            show:(_permisos.RecursosHumanos.show)
          },
          {
            id: 0,
            key: "miConfiguracion",
            name: "Mi Configuración",
            title: "Mi Configuración",
            to: "/MiConfiguracion",
            items: [
              {
                key: "sociedades",
                name: "Sociedades",
                title: "Sociedades",
                to: "/MiConfiguracion/Sociedades",
                items: []
              },
              {
                key: "visorColumnas",
                name: "Visor De Columnas",
                title: "Visor De Columnas",
                to: "/MiConfiguracion/VisorColumnas",
                items: []
              },
              {
                key: "misDatos",
                name: "Mis Datos",
                title: "Mis Datos",
                to: "/MiConfiguracion/MisDatos",
                items: []
              }
            ],
            show:(_permisos.MiConfiguracion.show)
          },
          {
            key: "configuracionApp",
            name: "Configuración App",
            title: "Configuración App",
            to: "/ConfiguracionApp",
            className: "btn-menu-configurationApp",
            items: [],
            show:(_permisos.ConfiguracionApp.show)
          },
          {
            id:0,
            key: "facturaciones",
            name: "Facturación",
            title: translate('facturacion'),
            to: "/Facturaciones",
            items: [
              {
                key: "facturacionExpatriados",
                name: translate("facturacion-expatriados"),
                title: translate("facturacion-expatriados"),
                to: "/Facturaciones/Expatriados",
                items: [],
                show:(_permisos.Facturacion.subMenu.facturacion)
              },
              {
                key: "facturacionExpatriadosValidaciones",
                name: translate("validaciones-expatriados"),
                title: translate("validaciones-expatriados"),
                to: "/Facturaciones/Expatriados/Validaciones",
                items: [],
                show:(_permisos.Facturacion.subMenu.validaciones)
              },
              {
                key: "facturacionExpatriadosAjustes",
                name: translate("ajustes-expatriados"),
                title: translate("ajustes-expatriados"),
                to: "/Facturaciones/Expatriados/Ajustes",
                items: [],
                show:(_permisos.Facturacion.subMenu.ajustes)
              },
              {
                key: "informeProv",
                name: "Informe Prov/Def",
                title: "Informe Prov/Def",
                to: "/Facturaciones/Expatriados/Informes/ProvisionalDefinitivo",
                show:(_permisos.Facturacion.subMenu.informes)
              },
              {
                key: "informeProvDefMesAnterior",
                name: "Informe Prov/Def Mes Anterior",
                title: "Informe Prov/Def Mes Anterior",
                to: "/Facturaciones/Expatriados/Informes/ProvisionalDefinitivoMesAnterior",
                show:(currentUser.administraExpatriados===true || currentUser.perfil==='ADM')
              }
              
            ],
            show:(_permisos.Facturacion.show)
          }
      ]},[currentUser,translate]);

    let [activeItem, setActiveItem] = useState(menuItems[_permisosRolExpatriado?4:0].name);



    const filtraMenuPermisos = useCallback((menuItems: Array<navigationType>, perfil: string) => {

      const filterData = (arr:any) => {
        return arr.reduce(
          (acc:any, item:any) => {
            const newItem:navigationType = item;
      
            if (item.items) {
              newItem.items = filterData(item.items);
            }
            if ((newItem.excludeperfil === undefined || (newItem.excludeperfil !== undefined && !newItem.excludeperfil.includes(perfil))) 
              && (newItem.perfil === undefined || (newItem.perfil !== undefined && newItem.perfil.includes(perfil)))
              && (newItem.show === undefined || newItem.show===true)){
              acc.push(newItem);
            }
            
            return acc;
          },
          []
        );
      }
      
      return filterData(menuItems)
     
    },[])

    const doNavigation = useCallback((newLocation: any) => {
        props.history.push(newLocation);
    },[props.history])

    const createNewLocation = useCallback((path: any) => {
        const currentLocation = props.location;
        return {
          pathname: path,
          state: {
            from:
              currentLocation && currentLocation.pathname
                ? currentLocation.pathname
                : "/nofound",
          },
        };
      },[props.location])
    
      const handleItemClicked = useCallback((event: any, data: any) => {
        
        if (data.to) {
          doNavigation(createNewLocation(data.to));
          setActiveItem(data.name);
        } else {
          switch (data.name.toLowerCase()) {
            case "logout":
              setUser(undefined)
              AuthenticationProvider.doLogout(() => {
                doNavigation(createNewLocation("/login"));
              });
              break;
            // case "contexto":
            //   doNavigation(createNewLocation("/Configuracion"));
          }
        }
        return;
      },[createNewLocation, doNavigation])

      const getIconMenu = useMemo(() =>{
        return (
          <EuiHeaderSectionItem>
            <EuiIcon type={reactSvg} size="xl" title="Elecnor Partes Estructura" className="menuIcon"/>
          </EuiHeaderSectionItem>
        )
      },[])

      const getLinksMenu = useMemo(() =>{
        return(
          <EuiHeaderLinks aria-label="App navigation dark theme example">
            {filtraMenuPermisos(menuItems, currentUser.perfil).map((item:any, key:any) => (
                (item.items && item.items.length > 0) ?
                <HeaderAppMenu data={item} handleItemClicked={handleItemClicked}/>
                : 
                <EuiHeaderLink className={item.className || ''} key={key} onClick={()=> {handleItemClicked('', item)}} isActive={activeItem === item.name}>{item.title}</EuiHeaderLink>
                
              ))}
          </EuiHeaderLinks>
        )
      },[menuItems, currentUser, activeItem, handleItemClicked, filtraMenuPermisos]);

      const getUserDataMenu = useMemo(() =>{
       return <LinkUser user={currentUser} handleExit={handleItemClicked} exitParams={{name:"logout"}} translate={translate}/>
      },[currentUser, handleItemClicked,translate])

      // const getEmailButton = useMemo(() =>{
      //   return <EmailSendButton/>
      //  },[])
      
       const getButtonConfigApp = useMemo(() =>{
        return <StateApp translate={translate}/>
       },[translate])

       const getLanguageSelection = useMemo(() =>{
        return <SelectorIdioma/>
       },[])

       const getProfileSelection = () =>{
        return <SelectorPerfil profile={{value:currentUser.perfil, label:currentUser.nombrePerfil}} rol={_permisosRolExpatriado!==undefined?translate(_permisosRolExpatriado.RolKey):undefined}/>
       }

       const getInfo = ()=>{
        return(
          <EuiFlexGroup gutterSize="none">
            {/* <EuiFlexItem>{getEmailButton}</EuiFlexItem> */}
            <EuiFlexItem>{getLanguageSelection}</EuiFlexItem>
            <EuiFlexItem>
              <EuiFlexGroup gutterSize="none">
                <EuiFlexItem grow={false}>{getButtonConfigApp}</EuiFlexItem>
                <EuiFlexItem>{getProfileSelection()}</EuiFlexItem>
                <EuiFlexItem grow={false}>{getUserDataMenu}</EuiFlexItem>
              </EuiFlexGroup>
            </EuiFlexItem>
          </EuiFlexGroup>
        )
       }

      return(
        <EuiHeader theme="dark" sections={[
            {
              items: [
                getIconMenu,
                getLinksMenu
              ]},
              {
                items:[getInfo()]
              }
          ]}
        />        
      );
  }

  const HeaderAppMenu = (props: any) => {
    const idGenerator = htmlIdGenerator();
    const popoverId = idGenerator('popover');
    const keypadId = idGenerator('keypad');
  
    const [isOpen, setIsOpen] = useState(false);
  
    const onMenuButtonClick = useCallback(() => {
      setIsOpen(!isOpen);
    },[isOpen])
  
    const closeMenu = () => {
      setIsOpen(false);
    };
  
    const button = useMemo(() =>{
      return(
        <EuiHeaderSectionItemButton
          key={'headerSection'}
          aria-controls={keypadId}
          aria-expanded={isOpen}
          aria-haspopup="true"
          //onMouseOver={onMenuButtonClick}
          onClick={onMenuButtonClick}
          >
          <EuiHeaderLink key={props.data.name} >{props.data.title}</EuiHeaderLink>
        </EuiHeaderSectionItemButton>
      )
      },[keypadId,isOpen, onMenuButtonClick, props.data])

    const getPanels = useMemo(() =>{
      const data = {...props.data}

      let newItems = data.items.map((d:any)=>{
        let link = {key:d.key,onClick:()=> {closeMenu();props.handleItemClicked("",d)}}
        return {...d,...link}
      })
      data.items = [...newItems];
      return [data];
    },[props])
  
    return (
      <EuiPopover
        id={popoverId}
        key={popoverId}
        ownFocus
        button={button}
        isOpen={isOpen}
        anchorPosition="downCenter"
        panelStyle={{padding: "1px"}}
        closePopover={closeMenu}>
        <EuiContextMenu initialPanelId={0} panels={getPanels}/>
      </EuiPopover>
    );
  }
  
export const GlobalNavigation = withRouter(Navigation);